import io from "socket.io-client";
import { urlServerSocket } from "../config/GlobalConstant";
import localStorage from "../utils/hooks/useLocalStorage";
let socket = io(urlServerSocket, {
  transports: ['websocket', 'polling'],
  reconnection: true
});

const socketLogic = () => {
  //let socketStatus = false;

  //Connection and disconnection to the server
  const checkStatus = () => {
    socket.on("connect", () => {
     
      //socketStatus = true;

      const userId = localStorage().getItem('idProfile');

     if (userId) userConnect(userId);
    });

    socket.on("disconnect", () => {
      console.log();
      //socketStatus = false;
    });

    return socketLogic;
  };

  //emit standar
  const emit = (events, payload, callback) => {
    socket.emit(events, payload, callback);
  }
  const listenAllEvents = (events, callback) => {
    socket.on(events, callback);
  }
  const removeListener = (events,callback) => {
    console.log("remove")
    if(callback){
      console.log("remove callback")
      socket.off(events,callback);
    }else{
      console.log("remove no calback")
      socket.off(events);
    }
  
  }

  //change user connection status and add him his socketID
  const userConnect = (idUser) => {
    emit("user-connect", idUser, (resp) => {
      console.log();
      return resp
    });
  }
  //change user connection status and delete him his socketID
  const userDisconnect = (idUser) => {
    emit("user-disconnect", idUser, (resp) => {
      // console.log();
      return resp
    });
  }

  //Create room from forntend
  const createChatRoom = (nameRoom) => {
    emit("create-room", nameRoom, (resp) => {
      console.log();
      return resp
    });
  }

  //Create room from forntend
  const message = async () => {
    socket.on("private-message", (resp) => {
      console.log();
      return resp
    });
  }
  
  const setSocketId = async (id) => {
    emit("set-socketId", id, (resp) => {
      return resp
    });
  }


  //change user connection status and add him his socketID
  const chatConnect = (ChatRoom) => {
    emit("chat-connect", ChatRoom, (resp) => {
      return resp
    });
  }

  const joinRoom = (ChatRoomName) => {
    emit("join-room", ChatRoomName, (res) => {
 
    });
  }
  
  const leaveRoom = (ChatRoomName) => {
    emit("leave-room", ChatRoomName, (res) => {

    });
  }



  const newRoomClient  = (callback) => {
    socket.on("new-room-client", callback);
  }
  const newComment = (callback) => {
    socket.on("new-comment", callback);
  }



  return {
    checkStatus,
    emit,
    userConnect,
    userDisconnect,
    createChatRoom,
    listenAllEvents,
    removeListener,
    message,
    setSocketId,
    chatConnect,
    newRoomClient,
    joinRoom,
    leaveRoom,
    newComment
  };
};
export default socketLogic();